<h1>
    <a (click)="back()"><i class="fa fa-chevron-left"></i> Back</a>
</h1>